import { ApiResponse } from 'apisauce';
import { ErrorInfo } from '../../../shared/interfaces/error-info.interface';
import api from '../../../shared/services/utils/api/api.service';
import errorHelper from '../../../shared/services/utils/api/error-helper.service';

export const getModuleName = () => 'operation-module';

export interface ReservationsOperationsQuery {
  unitTypeId?: number;
  cityId?: string;
  areaId?: string;
  status?: string | string[];
  fromDate?: number;
  toDate?: number;
  propertyManagerId?: string;
}

export type ReservationsOperationsItem = {
  id: number;
  type: 'reservation' | 'blockDate' | string;
  unitTypeId?: number;
  unitTypeName?: string;
  roomId?: string;
  roomName?: string;
  propertyName?: string;
  areaName?: string;
  cityName?: string;
  checkInDate?: number;
  checkOutDate?: number;
  numberOfNights?: number;
  primaryGuestName?: string;
  primaryGuestPhone?: string;
  status?: string;
  source?: string;
  createdByUsername?: string;
  createdAt?: string;
  updatedAt?: string;
};

export type ReservationsOperationsSearchResponse = {
  data: ReservationsOperationsItem[];
  count?: number;
};

export async function reservationsOperationsSearch(
  query: ReservationsOperationsQuery,
  offset: number,
  limit: number
): Promise<ReservationsOperationsSearchResponse | ErrorInfo> {
  const normalized: ApiResponse<any, ErrorInfo> = await (
    api as any
  ).getReservationsOperationsSearch(query, offset, limit);

  if (normalized.ok) {
    const payload: any = normalized.data;

    // Most endpoints return ResponseModel: { data: <list>, count?: number }
    const list = payload?.data?.data ?? payload?.data ?? [];
    const count = payload?.data?.count ?? payload?.count;

    if (Array.isArray(list)) {
      return { data: list, count };
    }

    return errorHelper(0, '', getModuleName(), 'reservationsOperationsSearch');
  }

  return errorHelper(
    Number(normalized.status),
    (normalized.data as any)?.errorCode
      ? String((normalized.data as any)?.errorCode || '')
      : normalized.problem,
    getModuleName(),
    'reservationsOperationsSearch'
  );
}
